import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  ReleaseReleaseNoteProtocolsGetDetailRequest,
  ReleaseReleaseNoteProtocolsGetDetailResponse,
  ReleaseReleaseNoteProtocolsGetListResponse,
  ReleaseReleaseNoteProtocolsGetPopupResponse,
} from '~/swagger/data-contracts';
import { ReleaseNote } from '~/swagger/ReleaseNote';
import { http } from '../base';

const RELEASE_NOTE_QUERY_KEY = 'release-note';
const POPUP_QUERY_KEY = 'release-note-popup';
const releaseNoteApi = new ReleaseNote(http);

export const useReleaseNotePopupQuery = <TData>(
  options: UseQueryOptions<ReleaseReleaseNoteProtocolsGetPopupResponse, unknown, TData>
) => {
  return useQuery<ReleaseReleaseNoteProtocolsGetPopupResponse, unknown, TData>({
    queryKey: [POPUP_QUERY_KEY],
    queryFn: async () => {
      const { data } = await releaseNoteApi.popupList();
      return data;
    },
    ...options,
  });
};

export const useReleaseNoteListQuery = <TData>(
  options: UseQueryOptions<ReleaseReleaseNoteProtocolsGetListResponse, unknown, TData>
) => {
  return useQuery<ReleaseReleaseNoteProtocolsGetListResponse, unknown, TData>({
    queryKey: [RELEASE_NOTE_QUERY_KEY, 'list'],
    queryFn: async () => {
      const { data } = await releaseNoteApi.listList();
      return data;
    },
    ...options,
  });
};

export const useReleaseNoteDetailQuery = <TData>(
  request: ReleaseReleaseNoteProtocolsGetDetailRequest,
  options: UseQueryOptions<ReleaseReleaseNoteProtocolsGetDetailResponse, unknown, TData>
) => {
  return useQuery<ReleaseReleaseNoteProtocolsGetDetailResponse, unknown, TData>({
    queryKey: [RELEASE_NOTE_QUERY_KEY, 'detail', request],
    queryFn: async () => {
      const { data } = await releaseNoteApi.detailCreate(request);
      return data;
    },
    ...options,
  });
};
